<template>
    <div class="billing-details">
        <template v-if="plan && plan.hasTieredLocations">
            <p class="billing-details__heading">Location pricing</p>
            <ul>
                <li v-for="(tier, index) in plan.locationTiers" :key="`loc-${index}`">
                    {{ formatLocationTier(tier, index) }}
                </li>
            </ul>
            <p class="billing-details__heading">Confirmed referral fees</p>
            <ul>
                <li v-for="(tier, index) in plan.referralTiers" :key="`ref-${index}`">
                    {{ formatReferralTier(tier, index) }}
                </li>
            </ul>
            <p>Annual location fees charge 8 months for 12. Referral fees stay monthly.</p>
        </template>
        <template v-else-if="plan && plan.hasExtraSeats">
            <p>
                Includes {{ plan.includedSeats }} provider seats. Extra seats are ${{ plan.extraSeatMonthlyPrice }}/mo (${{
                    plan.extraSeatAnnualPrice
                }}/yr). Office staff are free.
            </p>
            <p v-if="plan.extraReferralPrice">
                Extra inbound referrals beyond the monthly allowance are ${{ plan.extraReferralPrice }} each.
            </p>
        </template>
        <template v-else-if="plan && plan.extraReferralPrice">
            <p>Extra inbound referrals beyond the monthly allowance are ${{ plan.extraReferralPrice }} each.</p>
            <p>Annual plans charge 8 months for 12 on the base fee. Referral overages stay monthly.</p>
        </template>
        <template v-else>
            <p>
                For custom or enterprise needs, contact
                <a class="billing-details--email" :href="salesMailto">{{ salesEmail }}</a>
                .
            </p>
        </template>
    </div>
</template>

<script>
    import { getSalesMailto, SALES_EMAIL } from 'services/billingPlanHelpers'

    export default {
        props: {
            plan: { type: Object, default: null },
        },

        computed: {
            salesMailto() {
                return getSalesMailto()
            },
            salesEmail() {
                return SALES_EMAIL
            },
        },

        methods: {
            formatLocationTier(tier, index) {
                const prev = index === 0 ? 1 : (this.plan.locationTiers[index - 1].upTo || 0) + 1
                const range = tier.upTo == null ? `${prev}+` : `${prev}–${tier.upTo}`
                return `Locations ${range}: $${tier.monthlyPrice}/mo each`
            },

            formatReferralTier(tier, index) {
                const prev = index === 0 ? 1 : (this.plan.referralTiers[index - 1].upTo || 0) + 1
                const range = tier.upTo == null ? `${prev}+` : `${prev}–${tier.upTo}`
                return `Referrals ${range}: $${tier.price} each (confirmed)`
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .billing-details {
        margin-top: 30px;
        font-size: 13px;
        line-height: 1.5;

        &__heading {
            font-weight: 600;
            margin-top: 12px;
            margin-bottom: 4px;
        }

        ul {
            padding-left: 18px;
            margin: 0 0 8px;
        }

        &--email {
            color: $color--accent-1;
            cursor: pointer;
        }
    }
</style>
